import { useEffect } from "react";

interface Props {
  toastData: Array<any>;
  setToastData: React.Dispatch<React.SetStateAction<any[]>>;
  rightWord?: string;
  gameResult?: string; // <-- Add this prop
}

const Toast = ({ toastData, setToastData, rightWord, gameResult }: Props) => {
  console.log("gameResult:", gameResult);
  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (toastData.length > 0 && toastData[0] !== rightWord) {
      timer = setTimeout(() => {
        setToastData((state) => {
          const newData = [...state];
          newData.pop();
          return newData;
        });
      }, 1000 / toastData.length);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [rightWord, toastData, setToastData]);
  return (
    <div className="absolute top-[15.3rem]">
      {toastData
        ? toastData.map((toast: string, index: number) => (
            <div
              key={index}
              className="flex flex-col justify-center items-center w-auto px-2 h-auto rounded-md bg-black text-white text-xl mb-5"
            >
              <p>
                {toast === rightWord ? `الكلمة الصحيحة :  ${rightWord}` : toast}
              </p>
              {(gameResult === "win" || gameResult === "lose") && (
                <p dir="ltr">
                  <a
                    href={`https://www.livingarabic.com/en/search?q=${rightWord}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Click here to search for this term.
                  </a>
                </p>
              )}
            </div>
          ))
        : null}
    </div>
  );
};

export default Toast;
